exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".saved-actions[data-v-4f06ac04]{display:flex;justify-content:space-between;margin-top:1.3rem}", ""]);

// exports
